// Keep a manual copy of AclAction enum
// import type { AclAction } from '@sine/sine-core-api-types';
export enum AclAction {
  APIKEY_ADMIN = 'APIKEY_ADMIN',
  ASSET_READ = 'ASSET_READ',
  ASSET_WRITE = 'ASSET_WRITE',
  BILLING_WRITE = 'BILLING_WRITE',
  DISPLAY_READ = 'DISPLAY_READ',
  DISPLAY_LINK = 'DISPLAY_LINK',
  DISPLAY_MESSAGE = 'DISPLAY_MESSAGE',
  DISPLAY_REMOVE = 'DISPLAY_REMOVE',
  DEVICE_PERMISSION_WRITE = 'DEVICE_PERMISSION_WRITE',
  H_PROFILE_INVITATION = 'H_PROFILE_INVITATION',
  H_PROFILE_PASS = 'H_PROFILE_PASS',
  H_PROFILE_PRINT = 'H_PROFILE_PRINT',
  H_PROFILE_SIGN_IN = 'H_PROFILE_SIGN_IN',
  HOST_MESSAGE = 'HOST_MESSAGE',
  HOST_READ = 'HOST_READ',
  HOST_UPLOAD = 'HOST_UPLOAD',
  HOST_WRITE = 'HOST_WRITE',
  TEAM_SCOPED_HOST_WRITE = 'TEAM_SCOPED_HOST_WRITE',
  INVITATION_CREATE = 'INVITATION_CREATE',
  INVITATION_MESSAGE = 'INVITATION_MESSAGE',
  INVITATION_READ = 'INVITATION_READ',
  INVITATION_UPDATE = 'INVITATION_UPDATE',
  PASS = 'PASS',
  PASS_ACCESS = 'PASS_ACCESS',
  PASS_DELETE = 'PASS_DELETE',
  PASS_MESSAGE = 'PASS_MESSAGE',
  PASS_UPDATE = 'PASS_UPDATE',
  PERMISSION_WRITE = 'PERMISSION_WRITE',
  PRINT = 'PRINT',
  REPORTING = 'REPORTING',
  REPORTING_EXPORT = 'REPORTING_EXPORT',
  REPORTING_WRITE = 'REPORTING_WRITE',
  SAML_WRITE = 'SAML_WRITE',
  SIGN_IN = 'SIGN_IN',
  SIGN_OUT = 'SIGN_OUT',
  SITE = 'SITE',
  SITE_CREATE = 'SITE_CREATE',
  SITE_DELETE = 'SITE_DELETE',
  SITE_INTEGRATIONS = 'SITE_INTEGRATIONS',
  SITE_READ = 'SITE_READ',
  SITE_UPDATE = 'SITE_UPDATE',
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  TEAM_ADMIN = 'TEAM_ADMIN',
  CHECKLIST_READ = 'WATCHLIST_READ',
  CHECKLIST_WATCH = 'WATCHLIST_WATCH',
  CHECKLIST_WRITE = 'WATCHLIST_WRITE',
  LOBBY_CREATE = 'LOBBY_CREATE',
  LOBBY_UPDATE = 'LOBBY_UPDATE',
  LOBBY_READ = 'LOBBY_READ',
  LOBBY_DELETE = 'LOBBY_DELETE',
  ROLL_CALL_READ = 'ROLL_CALL_READ',
}

/**
 * @deprecated Use {@link AclAction} instead
 */
export const USER_ACTIONS = {
  APIKEY_ADMIN: 'APIKEY_ADMIN',
  BILLING_WRITE: 'BILLING_WRITE',
  DISPLAY_READ: 'DISPLAY_READ',
  DISPLAY_LINK: 'DISPLAY_LINK',
  DISPLAY_MESSAGE: 'DISPLAY_MESSAGE',
  DISPLAY_REMOVE: 'DISPLAY_REMOVE',
  DEVICE_PERMISSION_WRITE: 'DEVICE_PERMISSION_WRITE',
  H_PROFILE_INVITATION: 'H_PROFILE_INVITATION',
  H_PROFILE_PASS: 'H_PROFILE_PASS',
  H_PROFILE_PRINT: 'H_PROFILE_PRINT',
  H_PROFILE_SIGN_IN: 'H_PROFILE_SIGN_IN',
  HOST_MESSAGE: 'HOST_MESSAGE',
  HOST_READ: 'HOST_READ',
  HOST_UPLOAD: 'HOST_UPLOAD',
  HOST_WRITE: 'HOST_WRITE',
  TEAM_SCOPED_HOST_WRITE: 'TEAM_SCOPED_HOST_WRITE',
  INVITATION_CREATE: 'INVITATION_CREATE',
  INVITATION_MESSAGE: 'INVITATION_MESSAGE',
  INVITATION_READ: 'INVITATION_READ',
  INVITATION_UPDATE: 'INVITATION_UPDATE',
  PASS: 'PASS',
  PASS_ACCESS: 'PASS_ACCESS',
  PASS_DELETE: 'PASS_DELETE',
  PASS_MESSAGE: 'PASS_MESSAGE',
  PASS_UPDATE: 'PASS_UPDATE',
  PERMISSION_WRITE: 'PERMISSION_WRITE',
  PRINT: 'PRINT',
  REPORTING: 'REPORTING',
  REPORTING_EXPORT: 'REPORTING_EXPORT',
  REPORTING_WRITE: 'REPORTING_WRITE',
  SAML_WRITE: 'SAML_WRITE',
  SIGN_IN: 'SIGN_IN',
  SIGN_OUT: 'SIGN_OUT',
  SITE: 'SITE',
  SITE_CREATE: 'SITE_CREATE',
  SITE_DELETE: 'SITE_DELETE',
  SITE_INTEGRATIONS: 'SITE_INTEGRATIONS',
  SITE_READ: 'SITE_READ',
  SITE_UPDATE: 'SITE_UPDATE',
  SYSTEM_ADMIN: 'SYSTEM_ADMIN',
  TEAM_ADMIN: 'TEAM_ADMIN',
  CHECKLIST_READ: 'WATCHLIST_READ',
  CHECKLIST_WATCH: 'WATCHLIST_WATCH',
  CHECKLIST_WRITE: 'WATCHLIST_WRITE',
  LOBBY_CREATE: 'LOBBY_CREATE',
  LOBBY_UPDATE: 'LOBBY_UPDATE',
  LOBBY_READ: 'LOBBY_READ',
  LOBBY_DELETE: 'LOBBY_DELETE',
};
